export enum GESTION_USUARIO_TYPES {
  // * --------------------------------------------------------------
  // * TYPES PARA LA CREACIÓN DE USUARIO = CU
  // * --------------------------------------------------------------
  CU_FORM_HANDLE_CHANGE = 'CU_FORM_HANDLE_CHANGE',
  CU_FORM_VERIFY_CODE_HANDLE_CHANGE = 'CU_FORM_VERIFY_CODE_HANDLE_CHANGE',
  CU_FORM_ADD_ERROR = 'CU_FORM_ADD_ERROR',
  CU_FORM_CHANGE_PAGE = 'CU_FORM_CHANGE_PAGE',
  CU_FORM_ADD_ERROR_VERIFY_CODE = 'CU_FORM_ADD_ERROR_VERIFY_CODE',
  CU_FORM_CLEAR = 'CU_FORM_CLEAR',
  CU_SHOW_MODAL_CONFIRMACION = 'CU_SHOW_MODAL_CONFIRMACION',
  CU_SHOW_MODAL_VERIFICACION = 'CU_SHOW_MODAL_VERIFICACION',
  CU_SHOW_MODAL_CONFIRMAR = 'CU_SHOW_MODAL_CONFIRMAR',
  CU_SHOW_MODAL_CREADO = 'CU_SHOW_MODAL_CREADO',
  CU_SET_SUCURSALES = 'CU_SET_SUCURSALES',
  CU_SET_SUCURSALES_ASIGNADAS = 'CU_SET_SUCURSALES_ASIGNADAS',
  CU_SET_ID_USUARIO_CREADO = 'CU_SET_ID_USUARIO_CREADO',

  // * --------------------------------------------------------------
  // * TYPES PARA LA LISTA USUARIO = LU
  // * --------------------------------------------------------------
  LU_SET_ARRAY_USUARIOS = 'LU_SET_ARRAY_USUARIOS',
  LU_SET_USUARIOS = 'LU_SET_USUARIOS',
  LU_FORM_BUSCAR = 'LU_FORM_BUSCAR',
  LU_CLEAR = 'LU_CLEAR',
  LU_SHOW_MODAL_ACEPTAR_RECHAZAR = 'LU_SHOW_MODAL_ACEPTAR_RECHAZAR',
  LU_SHOW_MODAL_SUCURSALES = 'LU_SHOW_MODAL_SUCURSALES',
  LU_SHOW_MODAL_RESET_PASSWORD = 'LU_SHOW_MODAL_RESET_PASSWORD',
  LU_SHOW_MODAL_PRINT = 'LU_SHOW_MODAL_PRINT',
  LU_SHOW_MODAL_ESTATUS = 'LU_SHOW_MODAL_ESTATUS',
  LU_SHOW_MODAL_ELIMINAR_USUARIO = 'LU_SHOW_MODAL_ELIMINAR_USUARIO',
  LU_SET_SUCURSALES = 'LU_SET_SUCURSALES',
  LU_SET_SUCURSALES_ASIGNADAS = 'LU_SET_SUCURSALES_ASIGNADAS',
  LU_SET_USUARIO_SELECCIONADO = 'LU_SET_USUARIO_SELECCIONADO',
  LU_CLEAR_FORM_BUSCAR = 'LU_CLEAR_FORM_BUSCAR',

  // * --------------------------------------------------------------
  // * TYPES PARA LA EDITAR USUARIO = EU
  // * --------------------------------------------------------------
  EU_FORM_EDITAR_HANDLE_CHANGE = 'EU_FORM_EDITAR_HANDLE_CHANGE',
  EU_FORM_EDITAR_ADD_ERROR = 'EU_FORM_EDITAR_ADD_ERROR',
  EU_SHOW_MODAL_ELIMINAR_USUARIO = 'EU_SHOW_MODAL_ELIMINAR_USUARIO',
  EU_SET_USUARIO_SELECCIONADO = 'EU_SET_USUARIO_SELECCIONADO',
  EU_CLEAR = 'EU_CLEAR',

  // * --------------------------------------------------------------
  // * TYPES PARA ESTADOS DE DOCUMENTO = ED
  // * --------------------------------------------------------------
  ED_SET_ARRAY_ORIGINAL = 'ED_SET_ARRAY_ORIGINAL',
  ED_SET_ARRAY_FILTRADO = 'ED_SET_ARRAY_FILTRADO',
  ED_FORM_BUSCAR = 'ED_FORM_BUSCAR',
  ED_CLEAR_FORM_BUSCAR = 'ED_CLEAR_FORM_BUSCAR',
  ED_CLEAR = 'ED_CLEAR',
  ED_FORM_CREAR = 'ED_FORM_CREAR',
  ED_FORM_CREAR_ADD_ERROR = 'ED_FORM_CREAR_ADD_ERROR',
  ED_CLEAR_FORM_CREAR = 'ED_CLEAR_FORM_CREAR',
  ED_SHOW_MODAL_CREAR_EDITAR = 'ED_SHOW_MODAL_CREAR_EDITAR',
  ED_SHOW_MODAL_DOC_CREAR_EDITAR = 'ED_SHOW_MODAL_DOC_CREAR_EDITAR',
  ED_SHOW_MODAL_ELIMINAR = 'ED_SHOW_MODAL_ELIMINAR',
  ED_SHOW_MODAL_CHANGE_ESTATUS = 'ED_SHOW_MODAL_CHANGE_ESTATUS',
  ED_SET_DOCUMENTOSELECCIONADO = 'ED_SET_DOCUMENTOSELECCIONADO',

  // * --------------------------------------------------------------
  // * TYPES PARA EL PERFIL DE USUARIO = PF
  // * --------------------------------------------------------------
  PF_FORM_HANDLE_PROFILE = 'PF_FORM_HANDLE_PROFILE',

  // * --------------------------------------------------------------

  // * --------------------------------------------------------------
  // * TYPES PARA DOCUMENTOS Y SUCURSALES
  // * --------------------------------------------------------------
  SU_SUCURALES_LIST = 'SU_SUCURALES_LIST',
  SU_SET_FORM_SUCURSAL = 'SU_SET_FORM_SUCURSAL',
  SU_SET_FORM_DOC_SUCURSAL = 'SU_SET_FORM_DOC_SUCURSAL',
  SU_SET_ERRORS_FORM_SUCURSAL = 'SU_SET_ERRORS_FORM_SUCURSAL',
  SU_SET_ERRORS_FORM_DOC_SUCURSAL = 'SU_SET_ERRORS_FORM_DOC_SUCURSAL',
  SU_CLEAR_FORM_SUCURSAL = 'SU_CLEAR_FORM_SUCURSAL',
  SU_CLEAR_FORM_DOC_SUCURSAL = 'SU_CLEAR_FORM_DOC_SUCURSAL',

  SU_DOCUMENTOS_SUCURALES_LIST = 'SU_DOCUMENTOS_SUCURALES_LIST',
}
